import React from 'react';
import VmSvgImage from '../../../../../../util/VmSvgImage';
import leadStyles from '../../../../../../styles/leads.module.css';
import styles from '../../../../../../styles/OccasionSlide.module.css';
import Icon from '../../../../../../layouts/common/icons/Icon';

export default function CheckboxOption(props) {
    //style={{backgroundColor: `${props.item.isSelected ? "#f5f5f5" : "#fff"}`}}
  const renderSelectIcon = () => {
    return (
      props.item.isSelected  ?
        <>
          {
            props.selectedIcon ?
            <Icon style={{width:"18px"}} iconName={props.selectedIcon}/>
            :
            <img src="https://cdn.venuemonk.com/images/icons/vm-radio-black-active.svg" height="18px"
            width="18px" />
            

          } 
        </> 
        :
        props.icon ?   <Icon style={{width:"18px"}} iconName={props.icon}/> :
        <img src="https://cdn.venuemonk.com/images/icons/vm-radio-black.svg" height="18px"
          width="18px" />
    )
  }

    const rowClass = props.item.isCustomOccasion
      ? `${props.item.isSelected ? styles['occasion-row--selected'] : styles['occasion-row']} ${styles['occasion-row-base']}`
      : '';

    return (
        <div
            className={`${props.item.isSelected ? `${leadStyles['vm-leadform-checkbox-item']} ${leadStyles['vm-leadform-option-element']} ${leadStyles['vm-leadform-selected-option']}` : `${leadStyles['vm-leadform-checkbox-item']} ${leadStyles['vm-leadform-option-element']} ${leadStyles['vm-leadform-unselected-option']}`} ${rowClass}`.trim()}
            style={props.item.isCustomOccasion ? { alignItems: 'flex-start' } : {}}
            onClick={() => {
                props.handleOptionSelect(props.slideId, props.elementId, props.item._id, props.item.value)
            }}
        >
            <div className={`${leadStyles['vm-leadform-option-element-icon']} ${props.item.isCustomOccasion ? styles['occasion-radio-cell'] : ''}`.trim()}>
                {/*<i style={{marginRight: "10px"}} className={props.item.isSelected ? props.element.selectedIcon : props.element.icon} />*/}
                {/* <VmSvgImage
                    targetClass={leadStyles['vm-leadform-select-icon']}
                    iconName={props.item.isSelected ? props.selectedIcon : props.icon}
                /> */}
                {renderSelectIcon()}
            </div>
            {props.item.isImageAvailable ?
                <div style={{
                    position: "relative",
                    float: "left",
                    marginLeft: "10px",
                    marginRight: "10px"
                }}>
                    <img src={props.item.image}
                         alt={props.item.image_alt_text}
                         className={leadStyles["vm-leadform-option-element-image"]}
                    />
                </div>
                : null
            }
            {props.item.isCustomOccasion ?
                <div className={styles['occasionslide-value-rightcontainer']}>
                    <p className={styles['occasionslide-value']}>{props.item.label}</p>
                    <p className={styles['occasionslide-subvalue']}>{props.item.occasions.join(', ')}</p>
                </div>
                :
                <div style={{
                    position: "relative",
                    float: "left",
                    marginLeft: "10px",
                    alignContent: "center",
                    display: "flex",
                    height: "46px"
                }}>
                    <p className={leadStyles["vm-leadform-option-element-label"]}>{props.item.label}</p>
                </div>
            }
        </div>
    );
}
